import { render, staticRenderFns } from "./BatchIntegrationDetailDialog.vue?vue&type=template&id=563f2858&"
import script from "./BatchIntegrationDetailDialog.vue?vue&type=script&lang=js&"
export * from "./BatchIntegrationDetailDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports